// Supported iOS versions can route Web Audio as playback instead of ambient.
// Keep microphone capture and game sounds on a cooperative audio session.
const playback = new Set();
const recording = new Set();
let previousType;
const update = () => {
    const session = navigator.audioSession;
    if (!session) return;
    try {
        if (previousType === undefined) previousType = session.type;
        session.type = recording.size ? 'play-and-record' : playback.size ? 'playback' : previousType;
        if (!recording.size && !playback.size) previousType = undefined;
    } catch { /* Experimental API; unsupported browsers retain default routing. */ }
};
export const acquireAudioSession = (capture = false) => {
    const token = {};
    const owners = capture ? recording : playback;
    owners.add(token); update();
    return () => { if (owners.delete(token)) update(); };
};
